import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../Services/user.service';
import { ProfileCompletionService } from '../../Services/profile-completion.service';
import { superseeConfig } from 'src/app/superseeConfig';
import { normalizeTeamSizeForSelect } from 'src/app/onboarding-checklist/team-size.util';
import { SweetAlertService } from 'src/app/Services/sweet-alert.service';

@Component({
    selector: 'app-profile-completion-modal',
    templateUrl: './profile-completion-modal.component.html',
    styleUrls: ['./profile-completion-modal.component.css'],
    standalone: false
})
export class ProfileCompletionModalComponent implements OnInit {

    form: FormGroup;
    teamSizeOptions = superseeConfig.teamSizeOptions;

    constructor(
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<ProfileCompletionModalComponent>,
        private userService: UserService,
        private profileCompletionService: ProfileCompletionService,
        private sweetAlertService: SweetAlertService
    ) {
        this.form = this.fb.group({
            companyName: ['', [Validators.required]],
            phoneNumber: ['', [Validators.required, Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$')]],
            teamSize: ['', [Validators.required]]
        });
    }

    ngOnInit(): void {
        const user = this.userService.getCurrentUserValue();
        if (user && user.meta) {
            this.form.patchValue({
                companyName: user.meta.company_name,
                phoneNumber: user.meta.phone_number,
                teamSize: normalizeTeamSizeForSelect(user.meta.teamSize)
            });
        }
    }

    onSave(): void {
        if (this.form.valid) {
            const user = this.userService.getCurrentUserValue();
            const meta: any = {
                company_name: this.form.value.companyName,
                phone_number: this.form.value.phoneNumber,
                teamSize: this.form.value.teamSize
            };

            const updatedData = {
                name: user.name,
                meta
            };

            this.userService.updateUser(updatedData).subscribe(() => {
                this.userService.fetchCurrentUser().subscribe();

                this.profileCompletionService.clearSkipData();
                this.sweetAlertService.showAlert('Success!', 'Company profile saved successfully.', 'success');
                this.dialogRef.close();
            });
        }
    }

    onSkip(): void {
        this.profileCompletionService.recordSkip();
        this.dialogRef.close();
    }
} 